import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=613bc212&scoped=true"
import script from "./OfferDetails.vue?vue&type=script&lang=ts"
export * from "./OfferDetails.vue?vue&type=script&lang=ts"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=613bc212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bc212",
  null
  
)

export default component.exports